import Choices from "choices.js";


export const archiveFilter = () => {
  const form = document.getElementById('filters-form');
  if (!form) return;

  const selects = form.querySelectorAll('select');

  selects.forEach(select => {
    new Choices(select, {
      searchEnabled: false,
      shouldSort: false,
      searchChoices: false,
      itemSelectText: '',
      noResultsText: '',
      noChoicesText: '',
    });
  })

  function stripPageFromPath(pathname) {
    let cleaned = pathname.replace(/\/page\/\d+\/?$/,'/');
    cleaned = cleaned.replace(/\/{2,}/g, '/');
    if (cleaned === '') cleaned = '/';
    return cleaned;
  }

  function updateURL() {
    const params = new URLSearchParams();
    const category = form.querySelector('[name="category"]').value;
    const sort = form.querySelector('[name="sort"]').value;
    const search = form.querySelector('[name="s"]').value.trim();

    if (category) params.set('category', category);
    if (sort)     params.set('sort', sort);
    if (search) params.set('s', search);

    let basePath = stripPageFromPath(window.location.pathname);
    if (!basePath.endsWith('/')) basePath += '/';
    const qs = params.toString();
    const newUrl = basePath + (qs ? ('?' + qs) : '');

    window.location.href = newUrl;
  }

  selects.forEach(select => {
    select.addEventListener('change', updateURL);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    updateURL();
  });
}
